import { makeStyles } from '@material-ui/core'

const useGlobalStyles = makeStyles(() => ({
  '@global': {
    body: {
      backgroundColor: '#fff',
    },
  },
}))

export default useGlobalStyles
